import { render, staticRenderFns } from "./standard-image-attribution.vue?vue&type=template&id=0f37c6cb&scoped=true"
import script from "./standard-image-attribution.vue?vue&type=script&lang=js"
export * from "./standard-image-attribution.vue?vue&type=script&lang=js"
import style0 from "./standard-image-attribution.vue?vue&type=style&index=0&id=0f37c6cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f37c6cb",
  null
  
)

export default component.exports